import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';

import { OfflineComponentsModule } from 'src/app/components/general/offline/offline.components.module';
import { UserRedeemCreditComponent } from 'src/app/components/user/user-redeem-credit/user-redeem-credit.component';

@NgModule({
    declarations: [
        UserRedeemCreditComponent,
    ],
    imports: [
        IonicModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        OfflineComponentsModule,
        // IonicSelectableModule,
        TranslateModule,
    ],
    exports: [
        UserRedeemCreditComponent,
    ]
})
export class UserComponentsModule { }
